import React from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

const EmptyTable = ({ textTableEmpty, columnsLength }) => (
    <TableRow selectable={false}>
        <TableRowColumn colSpan={columnsLength}>
            <p style={{ textAlign: 'center' }}>{textTableEmpty}</p>
        </TableRowColumn>
    </TableRow>
);

EmptyTable.propTypes = {
    textTableEmpty: PropTypes.string.isRequired,
    columnsLength: PropTypes.number.isRequired,
};

export default EmptyTable;
